module.exports = __webpack_public_path__ + "img/og-image_handbook_pocket_cn.af4f7b5.jpg";